module.exports = __webpack_public_path__ + "static/media/Desktop_-_Food-and-Wine-Banner-2440x300@2x.82004c22.jpg";